import { ChangeEvent, FC, useEffect, useState } from "react";
import styles from "./coursesForm.module.css";
import { Buttons } from "../..";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Button, Col, notification, Row, Select } from "antd";
import { initialValuesObj } from "./coursesForm.types";
import UseCreateCourses from "../../../api/useCreateCourses";
import UseUpdateCourses from "../../../api/useUpdateCourses";
import UseGetCourseByIdBackOffice from "../../../api/useGetCourseByIdBackOffice";
import {
  errorNotification,
  successNotification,
  updatedNotification,
} from "./utils";
import { CourseInput } from "./../../../__generated__/gql-types/globalTypes";
import {
  GetCourses_getCourses,
  GetCourses_getCourses_lessons,
} from "../../../__generated__/gql-types/GetCourses";
import { GetGrade_getGrades } from "../../../__generated__/gql-types/GetGrade";
import { GetSubjects_getSubjects } from "./../../../__generated__/gql-types/GetSubjects";
import { GetAxes_getAxes } from "../../../__generated__/gql-types/GetAxes";
import { GetThemes_getThemes } from "../../../__generated__/gql-types/GetThemes";
import { GetTags_getTags } from "../../../__generated__/gql-types/GetTags";
import { ActivityIndicator } from "../../ActivityIndicator";
import { useAxes } from "../../../hooks/useAxes";
import { useSubject } from "../../../hooks/useSubject";
import { useLessons } from "../../../hooks/useLessons";
import { useGrades } from "../../../hooks/useGrades";
import { useThemes } from "../../../hooks/useThemes";
import { useCourses } from "../../../hooks/useCourses";
import { useDispatch } from "react-redux";
import { useTags } from "../../../hooks/useTags";

const { Option } = Select;

const NewCourses: FC = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { axes, loading: loadingAxes } = useAxes();
  const { themes: theme, loading: loadingThemes } = useThemes();
  const { subjects, loading: loadingSubjects } = useSubject();
  const { lessons: lesson, loading: loadingLessons } = useLessons();
  const { grades: grade, loading: loadingGrades } = useGrades();
  const { courses, loading: loadingCourses } = useCourses();
  const { tags, loading: loadingTags } = useTags();
  const [lessonSelected, setLessonSelected] = useState<
    GetCourses_getCourses_lessons[]
  >([]);
  const [lessonSelected2425, setLessonSelected2425] = useState<
    GetCourses_getCourses_lessons[]
  >([]);
  const [lessonSelected2526, setLessonSelected2526] = useState<
    GetCourses_getCourses_lessons[]
  >([]);
  const [lessonSelectedAux, setLessonSelectedAux] = useState<
    GetCourses_getCourses_lessons[]
  >([]);
  const [initialValues, setInitialValues] =
    useState<CourseInput>(initialValuesObj);
  const [loading, setLoading] = useState(false);

  const getCourseById = UseGetCourseByIdBackOffice();
  const createCourse = UseCreateCourses();
  const updateCourse = UseUpdateCourses();
  const navigate = useNavigate();

  const fetchInfo = async () => {
    setLoading(true);
    try {
      if (id) {
        const courseData = await getCourseById({ courseId: id });
        if (courseData?.lessons && courseData?.lessons.length > 0) {
          let lessonsSerialized = courseData?.lessons.sort(
            (a, b) => a.order_by! - b.order_by!
          );
          setLessonSelected(lessonsSerialized);

          if (courseData?.nem || courseData?.english) {
            setLessonSelected2425(lessonsSerialized);
          }
          if (courseData?.program_2526 || courseData?.english_2526) {
            setLessonSelected2526(lessonsSerialized);
          }
          if (courseData?.english_2526_spark) {
            setLessonSelectedAux(lessonsSerialized);
          }
        }

        // inicializamos los valores del formulario
        setInitialValues({
          title: courseData?.title ?? "",
          description: courseData?.description ?? "",
          type: courseData?.type ?? "",
          themes: courseData?.themes ?? [],
          tags: courseData?.tags ?? [],
          axes: courseData?.axes ?? [],
          subject_id: Number(courseData?.subject_id) ?? 1,
          grade_id: courseData?.grade_id ? Number(courseData?.grade_id) : 3,
          threemester: courseData?.threemester
            ? Number(courseData?.threemester)
            : null,
          threemester_2017: courseData?.threemester_2017
            ? Number(courseData?.threemester_2017)
            : null,
          threemester_2526: courseData?.threemester_2526
            ? Number(courseData?.threemester_2526)
            : null,
          threemester_english: courseData?.threemester_english
            ? Number(courseData?.threemester_english)
            : null,
          threemester_english_2526: courseData?.threemester_english_2526
            ? Number(courseData?.threemester_english_2526)
            : null,
          threemester_english_2526_spark:
            courseData?.threemester_english_2526_spark
              ? Number(courseData?.threemester_english_2526_spark)
              : null,
          threemester_reading: courseData?.threemester_reading
            ? Number(courseData?.threemester_reading)
            : null,
          week: courseData?.week ? Number(courseData?.week) : null,
          week_2017: courseData?.week_2017
            ? Number(courseData?.week_2017)
            : null,
          week_2526: courseData?.week_2526
            ? Number(courseData?.week_2526)
            : null,
          week_english: courseData?.week_english
            ? Number(courseData?.week_english)
            : null,
          week_english_2526: courseData?.week_english_2526
            ? Number(courseData?.week_english_2526)
            : null,
          week_english_2526_spark: courseData?.week_english_2526_spark
            ? Number(courseData?.week_english_2526_spark)
            : null,
          week_reading: courseData?.week_reading
            ? Number(courseData?.week_reading)
            : null,
          sep_book_pages: courseData?.sep_book_pages
            ? courseData?.sep_book_pages
            : "",
          sep_book_pages_2017: courseData?.sep_book_pages_2017
            ? courseData?.sep_book_pages_2017
            : "",
          sep_book_pages_2526: courseData?.sep_book_pages_2526
            ? courseData?.sep_book_pages_2526
            : "",
          sep_book_pages_english: courseData?.sep_book_pages_english
            ? courseData?.sep_book_pages_english
            : "",
          sep_book_pages_english_2526: courseData?.sep_book_pages_english_2526
            ? courseData?.sep_book_pages_english_2526
            : "",
          sep_book_pages_english_2526_spark:
            courseData?.sep_book_pages_english_2526_spark
              ? courseData?.sep_book_pages_english_2526_spark
              : "",
          sep_book_pages_reading: courseData?.sep_book_pages_reading
            ? courseData?.sep_book_pages_reading
            : "",
          lessons_2425: courseData?.lessons_2425 ?? [],
          lessons_2526: courseData?.lessons_2526 ?? [],
          lessons_aux: courseData?.lessons_aux ?? [],
          lessons: courseData?.lessons ?? [],
          nem: courseData?.nem,
          hide_course_for_students: courseData?.hide_course_for_students,
          program_2017: courseData?.program_2017,
          program_2425: courseData?.program_2425,
          program_2526: courseData?.program_2526,
          english: courseData?.english,
          english_2526: courseData?.english_2526,
          english_2526_spark: courseData?.english_2526_spark,
          reading: courseData?.reading,
          month: courseData?.month ?? 1,
          math_fibonacci: courseData?.math_fibonacci ?? false,
          math_descartes: courseData?.math_descartes ?? false,
          sep_book_pages_math_fibonacci: courseData?.sep_book_pages_math_fibonacci ?? '',
          sep_book_pages_math_descartes: courseData?.sep_book_pages_math_descartes ?? '',
          threemester_math_fibonacci: courseData?.threemester_math_fibonacci ?? null,
          threemester_math_descartes: courseData?.threemester_math_descartes ?? null,
          week_math_fibonacci: courseData?.week_math_fibonacci ?? null,
          week_math_descartes: courseData?.week_math_descartes ?? null
        });
      } else {
        setInitialValues(initialValuesObj);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      notification["error"]({
        message: "Error",
        description:
          "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  };

  useEffect(() => {
    fetchInfo();
  }, [id]);

  const handleSubmit = async (values: any) => {
    let courseInput: CourseInput = {
      ...values,
      month: initialValues.nem ? initialValues.month : null,
      sep_book_pages: initialValues.sep_book_pages,
      sep_book_pages_2017: initialValues.sep_book_pages_2017,
      sep_book_pages_2526: initialValues.sep_book_pages_2526,
      sep_book_pages_english: initialValues.sep_book_pages_english,
      sep_book_pages_english_2526: initialValues.sep_book_pages_english_2526,
      sep_book_pages_english_2526_spark:
        initialValues.sep_book_pages_english_2526_spark,
      sep_book_pages_reading: initialValues.sep_book_pages_reading,
      threemester:
        initialValues.threemester === 0 ? null : initialValues.threemester,
      threemester_2017:
        initialValues.threemester_2017 === 0
          ? null
          : initialValues.threemester_2017,
      threemester_2526:
        initialValues.threemester_2526 === 0
          ? null
          : initialValues.threemester_2526,
      threemester_english:
        initialValues.threemester_english === 0
          ? null
          : initialValues.threemester_english,
      threemester_english_2526:
        initialValues.threemester_english_2526 === 0
          ? null
          : initialValues.threemester_english_2526,
      threemester_english_2526_spark:
        initialValues.threemester_english_2526_spark === 0
          ? null
          : initialValues.threemester_english_2526_spark,
      threemester_reading:
        initialValues.threemester_reading === 0
          ? null
          : initialValues.threemester_reading,
      nem: initialValues.nem,
      program_2017: initialValues.program_2017,
      program_2526: initialValues.program_2526,
      english: initialValues.english,
      english_2526: initialValues.english_2526,
      english_2526_spark: initialValues.english_2526_spark,
      reading: initialValues.reading,
      week: initialValues.week,
      week_2017: initialValues.week_2017,
      week_2526: initialValues.week_2526,
      week_english: initialValues.week_english,
      week_english_2526: initialValues.week_english_2526,
      week_english_2526_spark: initialValues.week_english_2526_spark,
      week_reading: initialValues.week_reading,
      type: "course",
      subject_id: initialValues.subject_id,
      hide_course_for_students: initialValues.hide_course_for_students,
      grade_id: initialValues.grade_id,
      // Limpiar themes, axes y tags para remover __typename
      themes: initialValues.themes?.map(theme => ({
        id: theme.id,
        name: theme.name,
      })) || [],
      axes: initialValues.axes?.map(axis => ({
        id: axis.id,
        name: axis.name,
      })) || [],
      tags: initialValues.tags?.map(tag => ({
        id: tag.id,
        name: tag.name,
      })) || [],
      lessons:
        initialValues.nem ||
        initialValues.program_2526 ||
        initialValues.english ||
        initialValues.english_2526 ||
        initialValues.english_2526_spark
          ? Array.from(
              new Set(
                lessonSelected2425
                  .concat(lessonSelected2526)
                  .map((lesson) => lesson.id)
              )
            ).map((id) => {
              const finalArray = lessonSelected2425
                .concat(lessonSelected2526)
                .concat(lessonSelectedAux);
              const finalLesson = finalArray.find((lesson) => lesson.id === id);

              return {
                id: finalLesson?.id,
                title: finalLesson?.title,
                lesson_type: finalLesson?.lesson_type,
                order_by: finalLesson?.order_by ?? finalArray.length,
              };
            })
          : Array.from(new Set(lessonSelected.map((lesson) => lesson.id))).map(
              (id) => {
                const lesson = lessonSelected.find((lesson) => lesson.id === id);
                return {
                  id: lesson?.id,
                  title: lesson?.title,
                  lesson_type: lesson?.lesson_type,
                  order_by: lesson?.order_by,
                };
              }
            ),
      lessons_2425: initialValues.lessons_2425,
      lessons_2526: initialValues.lessons_2526,
      lessons_aux: initialValues.lessons_aux,
    };
    setLoading(true);
    try {
      if (id) {
        const response = await updateCourse({
          courseInput: courseInput,
          updateCourseId: `${id}`,
        });
        response.data.updateCourse && updatedNotification();

        let index = courses.findIndex(
          (course) => course.id === response.data.updateCourse.id
        );
        let coursesUpdated = [...courses];
        coursesUpdated[index] = response.data
          .updateCourse as unknown as GetCourses_getCourses;
        dispatch({ type: "data/setCourses", payload: coursesUpdated });
        setLoading(false);
        return navigate(-1);
      } else {
        const createResponse = await createCourse(courseInput);
        createResponse && successNotification();
        let newCourses = [];
        let newCourse = createResponse.data
          .createCourse as unknown as GetCourses_getCourses;
        newCourses = [newCourse, ...courses];
        dispatch({ type: "data/setCourses", payload: newCourses });

        setLoading(false);
        return navigate(-1);
      }
    } catch (error) {
      console.log({ error });
      errorNotification();
      setLoading(false);
    }
  };

  const handleChangeAxes = (values: string[]) => {
    const axesValues = values!.map((value) => {
      let id = value.split("-")[1] !== undefined ? value.split("-")[0] : null;
      let name =
        value.split("-")[1] !== undefined ? value.split("-")[1] : value;

      const axe = axes!.find((axis) => axis?.id === id);

      if (axe) {
        return axe;
      } else {
        return {
          id,
          name,
        };
      }
    });

    initialValues.axes = axesValues;
    setInitialValues(initialValues);
  };

  const handleChangeThemes = (values: string[]) => {
    const themesValues = values!.map((value) => {
      let id = value.split("-")[1] !== undefined ? value.split("-")[0] : null;
      let name =
        value.split("-")[1] !== undefined ? value.split("-")[1] : value;

      const selectedTheme = theme!.find((th) => th?.id === value);

      if (selectedTheme) {
        return selectedTheme;
      } else {
        return {
          id,
          name,
        };
      }
    });

    initialValues.themes = themesValues;
    setInitialValues(initialValues);
  };

  const handleChangeTags = (values: string[]) => {
    const tagsValues = values!.map((value) => {
      let id = value.split("-")[1] !== undefined ? value.split("-")[0] : null;
      let name =
        value.split("-")[1] !== undefined ? value.split("-")[1] : value;

      const tag = tags!.find((tag) => tag?.id === id);

      if (tag) {
        return tag;
      } else {
        return {
          id,
          name,
        };
      }
    });

    initialValues.tags = tagsValues;
    setInitialValues(initialValues);
  };

  const handleChangeLessons = (value: string[]) => {
    let arrLessonSelected: GetCourses_getCourses_lessons[] = [];
    for (let i = 0; i < value.length; i++) {
      let lesson_type: string = value[i].split("-")[0];
      let id: string = value[i].split("-")[1];
      let title: string = value[i].split("-")[2];
      arrLessonSelected.push({
        id: `${id}`,
        title: title,
        order_by: i,
        lesson_type: lesson_type,
      });
    }
    setLessonSelected(arrLessonSelected);
  };

  const handleChangeLessons2425 = (value: string[]) => {
    let arrLessonSelected: GetCourses_getCourses_lessons[] = [];
    for (let i = 0; i < value.length; i++) {
      let lesson_type: string = value[i].split("-")[0];
      let id: string = value[i].split("-")[1];
      let title: string = value[i].split("-")[2];
      arrLessonSelected.push({
        id: `${id}`,
        title: title,
        order_by: i,
        lesson_type: lesson_type,
      });
    }

    setInitialValues({
      ...initialValues,
      lessons_2425: arrLessonSelected.map((obj) => Number(obj.id)),
    });
    setLessonSelected2425(arrLessonSelected);
  };

  const handleChangeLessons2526 = (value: string[]) => {
    let arrLessonSelected: GetCourses_getCourses_lessons[] = [];
    for (let i = 0; i < value.length; i++) {
      let lesson_type: string = value[i].split("-")[0];
      let id: string = value[i].split("-")[1];
      let title: string = value[i].split("-")[2];
      arrLessonSelected.push({
        id: `${id}`,
        title: title,
        order_by: i,
        lesson_type: lesson_type,
      });
    }
    setInitialValues({
      ...initialValues,
      lessons_2526: arrLessonSelected.map((obj) => Number(obj.id)),
    });
    setLessonSelected2526(arrLessonSelected);
  };

  const handleChangeLessonsAux = (value: string[]) => {
    let arrLessonSelected: GetCourses_getCourses_lessons[] = [];
    for (let i = 0; i < value.length; i++) {
      let lesson_type: string = value[i].split("-")[0];
      let id: string = value[i].split("-")[1];
      let title: string = value[i].split("-")[2];
      arrLessonSelected.push({
        id: `${id}`,
        title: title,
        order_by: i,
        lesson_type: lesson_type,
      });
    }
    setInitialValues({
      ...initialValues,
      lessons_aux: arrLessonSelected.map((obj) => Number(obj.id)),
    });
    setLessonSelectedAux(arrLessonSelected);
  };

  const axeSelectChildren: React.ReactNode[] = [];
  axes?.forEach((axe: GetAxes_getAxes, index: number) => {
    axeSelectChildren.push(
      <Option value={`${axe?.id}-${axe.name}`} key={index + `${new Date()}`}>
        {axe?.name}
      </Option>
    );
  });

  const tagSelectChildren: React.ReactNode[] = [];
  tags?.forEach((tag: GetTags_getTags, index: number) => {
    tagSelectChildren.push(
      <Option value={`${tag?.id}-${tag.name}`} key={index + `${new Date()}`}>
        {tag?.name}
      </Option>
    );
  });

  const handleChangeTrimester = (type: string) => (values: string[]) => {
    const trimesterValue = Number(values[0]);

    if (type === 'math_fibonacci' || type === 'math_descartes') {
      setInitialValues({
        ...initialValues,
        threemester: trimesterValue,
        [`threemester_${type}`]: trimesterValue,
      });
    } else {
      setInitialValues({
        ...initialValues,
        [type === 'base' ? 'threemester' : `threemester_${type}`]: trimesterValue,
      });
    }
  };

  const handleChangeBookPages = (type: string) => (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (type === 'math_fibonacci' || type === 'math_descartes') {
      setInitialValues({
        ...initialValues,
        sep_book_pages: value,
        [`sep_book_pages_${type}`]: value,
      });
    } else {
      setInitialValues({
        ...initialValues,
        [type === 'base' ? 'sep_book_pages' : `sep_book_pages_${type}`]: value,
      });
    }
  };

  const handleChangeWeek = (type: string) => (e: ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);

    if (type === 'math_fibonacci' || type === 'math_descartes') {
      setInitialValues({
        ...initialValues,
        week: value,
        [`week_${type}`]: value,
      });
    } else {
      setInitialValues({
        ...initialValues,
        [type === 'base' ? 'week' : `week_${type}`]: value,
      });
    }
  };

  const resolveLessonType = (lesson_type: string) => {
    if (lesson_type === "videolesson") {
      return "VL";
    }
    if (lesson_type === "audio") {
      return "AU";
    }
    if (lesson_type === "classroomguide") {
      return "OD";
    }
    if (lesson_type === "evaluation") {
      return "EV";
    }
    if (lesson_type === "manipulative_dynamics") {
      return "DM";
    }
    if (lesson_type === "slides") {
      return "DIA";
    }
    if (lesson_type === "vocabulary") {
      return "VO";
    }
    if (lesson_type === "book_pages") {
      return "PAG";
    }
    if (lesson_type === "redaction") {
      return "RE";
    }
    if (lesson_type === "literacy") {
      return "LE";
    }
    if (lesson_type === "listening") {
      return "LIST";
    }
    if (lesson_type === "conversation") {
      return "CO";
    }
    if (lesson_type === "audio_exam") {
      return "AU_EX";
    }
    if (lesson_type === "writing_exam") {
      return "WR_EX";
    }
    return "VL";
  };

  const handleDistributeLessons = () => {
    if (lessonSelected.length > 0) {
      const lessonsId = lessonSelected.map((obj) => Number(obj.id));
      initialValues.lessons_2425 = lessonsId;
      initialValues.lessons_2526 = lessonsId;
      initialValues.lessons_aux = lessonsId;

      const prevState = {
        nem: initialValues.nem,
        program_2526: initialValues.program_2526,
        english: initialValues.english,
        english_2526: initialValues.english_2526,
        english_2526_spark: initialValues.english_2526_spark,
      };
      setInitialValues({
        ...initialValues,
        nem: false,
        program_2526: false,
        english: false,
        english_2526: false,
        english_2526_spark: false,
      });

      setTimeout(() => {
        setInitialValues({
          ...initialValues,
          nem: prevState.nem,
          program_2526: prevState.program_2526,
          english: prevState.english,
          english_2526: prevState.english_2526,
          english_2526_spark: prevState.english_2526_spark,
        });
      }, 100);
    }
  };

  if (
    loading ||
    loadingAxes ||
    loadingGrades ||
    loadingLessons ||
    loadingSubjects ||
    loadingThemes ||
    loadingCourses ||
    loadingTags
  ) {
    return <ActivityIndicator />;
  }

  return (
    <div className={styles.container}>
      {id ? <h1>Editar Curso </h1> : <h1>Nuevo Curso </h1>}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ errors, handleReset, touched }) => {
          return (
            <Form className={styles.formContainer}>
              <label htmlFor="course">Título</label>
              <Field
                errors={errors}
                touched={touched}
                name="title"
                title="Titulo"
                type="text"
                className={styles.formFields}
                value={initialValues.title}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setInitialValues({
                    ...initialValues,
                    title: e.target.value,
                  });
                }}
              />

              <label htmlFor="course">Descripción</label>
              <Row>
                <Field
                  style={{ width: "100%" }}
                  rows="4"
                  as="textarea"
                  name="description"
                  id="description"
                  className={styles.formFields}
                  value={initialValues.description}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setInitialValues({
                      ...initialValues,
                      description: e.target.value,
                    });
                  }}
                />
              </Row>
              <ErrorMessage
                name="description"
                component="div"
                className={styles.error}
              />

              {/* MATERIA */}
              <Row style={{ marginBottom: 20 }}>
                <label htmlFor="course">Asignatura</label>
                <Field
                  id="subject_id"
                  name="subject_id"
                  as="select"
                  value={initialValues.subject_id ?? 1}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setInitialValues({
                      ...initialValues,
                      subject_id: Number(e.target.value),
                    });
                  }}
                  className={
                    errors.subject_id && touched.subject_id
                      ? styles.formFieldsError
                      : styles.formFieldSelect
                  }
                >
                  <option disabled value="">
                    Seleccionar
                  </option>
                  {subjects?.map(
                    (
                      subject: GetSubjects_getSubjects | null,
                      index: number
                    ) => {
                      return (
                        <option value={subject?.id} key={index}>
                          {subject?.name}
                        </option>
                      );
                    }
                  )}
                </Field>
                <br />
              </Row>

              {/* GRADO */}
              <Row style={{ marginBottom: 20 }}>
                <label htmlFor="grade_id">Grado</label>
                <Field
                  id="grade_id"
                  name="grade_id"
                  as="select"
                  className={
                    errors.grade_id && touched.grade_id
                      ? styles.formFieldsError
                      : styles.formFieldSelect
                  }
                  value={initialValues.grade_id ?? 3}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setInitialValues({
                      ...initialValues,
                      grade_id: Number(e.target.value),
                    });
                  }}
                >
                  <option disabled value="">
                    Seleccionar
                  </option>
                  {grade?.map(
                    (grade: GetGrade_getGrades | null, index: number) => {
                      return (
                        <option value={grade?.id} key={index}>
                          {grade?.name}
                        </option>
                      );
                    }
                  )}
                </Field>
                <ErrorMessage
                  name="grade_id"
                  component="div"
                  className={styles.error}
                />
                <br />
              </Row>

              {initialValues.subject_id === 1 && (
                <>
                  {/* PROGRAMA MATEMÁTICA FIBONACCI */}
                  <Row style={{ marginBottom: 20 }}>
                    <Col span={6}>
                      <label htmlFor=""> Páginas Matemática Fibonacci</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        placeholder="Ej: 1 - 2 - 3 ..."
                        name="sep_book_pages_math_fibonacci"
                        title="Páginas del libro"
                        type="text"
                        value={initialValues.sep_book_pages_math_fibonacci}
                        className={styles.formFields}
                        onChange={handleChangeBookPages('math_fibonacci')}
                      />
                    </Col>
                    <Col span={4} offset={1}>
                      <div style={{ marginTop: 30 }}>
                        <Field
                          type="checkbox"
                          name="math_fibonacci"
                          checked={initialValues.math_fibonacci}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setInitialValues({
                              ...initialValues,
                              math_fibonacci: e.target.checked
                            });
                          }}
                        />
                        <label htmlFor="math_fibonacci" style={{ marginLeft: "10px" }}>
                          Matemática Fibonacci
                        </label>
                      </div>
                    </Col>
                    <Col span={6}>
                      <label htmlFor=""> Dosificación por semana</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        name="week_math_fibonacci"
                        title="Dosificación por semana"
                        type="number"
                        defaultValue={initialValues.week_math_fibonacci}
                        className={styles.formFields}
                        onChange={handleChangeWeek('math_fibonacci')}
                      />
                    </Col>
                    <Col span={1}></Col>
                    <Col span={6}>
                      <label htmlFor="">Trimestre</label>
                      <Select
                        className={styles.formFields}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        defaultValue={
                          initialValues.threemester_math_fibonacci
                            ? [`${Number(initialValues.threemester_math_fibonacci)}`]
                            : ["0"]
                        }
                        onChange={handleChangeTrimester('math_fibonacci')}
                        options={[
                          { value: "0", label: "Seleccionar Trimestre" },
                          { value: "1", label: "1° trimestre" },
                          { value: "2", label: "2° trimestre" },
                          { value: "3", label: "3° trimestre" },
                        ]}
                      />
                    </Col>
                  </Row>

                  {/* PROGRAMA MATEMÁTICA DESCARTES */}
                  <Row style={{ marginBottom: 20 }}>
                    <Col span={6}>
                      <label htmlFor=""> Páginas Matemática Descartes</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        placeholder="Ej: 1 - 2 - 3 ..."
                        name="sep_book_pages_math_descartes"
                        title="Páginas del libro"
                        type="text"
                        value={initialValues.sep_book_pages_math_descartes}
                        className={styles.formFields}
                        onChange={handleChangeBookPages('math_descartes')}
                      />
                    </Col>
                    <Col span={4} offset={1}>
                      <div style={{ marginTop: 30 }}>
                        <Field
                          type="checkbox"
                          name="math_descartes"
                          checked={initialValues.math_descartes}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setInitialValues({
                              ...initialValues,
                              math_descartes: e.target.checked
                            });
                          }}
                        />
                        <label htmlFor="math_descartes" style={{ marginLeft: "10px" }}>
                          Matemática Descartes
                        </label>
                      </div>
                    </Col>
                    <Col span={6}>
                      <label htmlFor=""> Dosificación por semana</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        name="week_math_descartes"
                        title="Dosificación por semana"
                        type="number"
                        defaultValue={initialValues.week_math_descartes}
                        className={styles.formFields}
                        onChange={handleChangeWeek('math_descartes')}
                      />
                    </Col>
                    <Col span={1}></Col>
                    <Col span={6}>
                      <label htmlFor="">Trimestre</label>
                      <Select
                        className={styles.formFields}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        defaultValue={
                          initialValues.threemester_math_descartes
                            ? [`${Number(initialValues.threemester_math_descartes)}`]
                            : ["0"]
                        }
                        onChange={handleChangeTrimester('math_descartes')}
                        options={[
                          { value: "0", label: "Seleccionar Trimestre" },
                          { value: "1", label: "1° trimestre" },
                          { value: "2", label: "2° trimestre" },
                          { value: "3", label: "3° trimestre" },
                        ]}
                      />
                    </Col>
                  </Row>
                </>
              )}

              {initialValues.subject_id !== 16 && initialValues.subject_id !== 1 && (
                <>
                  {/* PROGRAMA 2425 */}
                  <Row style={{ marginBottom: 20 }}>
                    <Col span={6}>
                      <label htmlFor=""> Páginas 2024/2025</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        placeholder="Ej: 1 - 2 - 3 ..."
                        name="sep_book_pages"
                        title="Páginas del libro"
                        type="text"
                        value={initialValues.sep_book_pages}
                        className={styles.formFields}
                        onChange={handleChangeBookPages('base')}
                      />
                    </Col>
                    <Col span={4} offset={1}>
                      <div style={{ marginTop: 30 }}>
                        <Field
                          type="checkbox"
                          name="published"
                          checked={initialValues.nem}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setInitialValues({
                              ...initialValues,
                              nem: e.target.checked,
                            });
                          }}
                        />
                        <label htmlFor="nem" style={{ marginLeft: "10px" }}>
                          2024/2025 | NEM
                        </label>
                      </div>
                    </Col>
                    <Col span={6}>
                      <label htmlFor=""> Dosificación por semana</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        name="week"
                        title="Dosificación por semana"
                        type="number"
                        defaultValue={initialValues.week}
                        className={styles.formFields}
                        onChange={handleChangeWeek('base')}
                      />
                    </Col>
                    <Col span={1}></Col>
                    <Col span={6}>
                      <label htmlFor="">Trimestre</label>
                      <Select
                        className={styles.formFields}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        defaultValue={
                          initialValues.threemester
                            ? [`${Number(initialValues.threemester)}`]
                            : ["0"]
                        }
                        onChange={handleChangeTrimester('base')}
                        options={[
                          { value: "0", label: "Seleccionar Trimestre" },
                          { value: "1", label: "1° trimestre" },
                          { value: "2", label: "2° trimestre" },
                          { value: "3", label: "3° trimestre" },
                        ]}
                      />
                    </Col>
                  </Row>

                  {/* PROGRAMA 2526 */}
                  <Row style={{ marginBottom: 20 }}>
                    <Col span={6}>
                      <label htmlFor=""> Páginas 2025/2026</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        placeholder="Ej: 1 - 2 - 3 ..."
                        name="sep_book_pages_2526"
                        title="Páginas del libro"
                        type="text"
                        value={initialValues.sep_book_pages_2526}
                        className={styles.formFields}
                        onChange={handleChangeBookPages('2526')}
                      />
                    </Col>
                    <Col span={4} offset={1}>
                      <div style={{ marginTop: 30 }}>
                        <Field
                          type="checkbox"
                          name="published"
                          checked={initialValues.program_2526}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setInitialValues({
                              ...initialValues,
                              program_2526: e.target.checked,
                              month: 1,
                            });
                          }}
                        />
                        <label
                          htmlFor="program_2526"
                          style={{ marginLeft: "10px" }}
                        >
                          2025/2026
                        </label>
                      </div>
                    </Col>
                    <Col span={6}>
                      <label htmlFor=""> Dosificación por semana</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        name="week_2526"
                        title="Dosificación por semana"
                        type="number"
                        defaultValue={initialValues.week_2526}
                        className={styles.formFields}
                        onChange={handleChangeWeek('2526')}
                      />
                    </Col>
                    <Col span={1}></Col>
                    <Col span={6}>
                      <label htmlFor="">Trimestre</label>
                      <Select
                        className={styles.formFields}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        defaultValue={
                          initialValues.threemester_2526
                            ? [`${Number(initialValues.threemester_2526)}`]
                            : ["0"]
                        }
                        onChange={handleChangeTrimester('2526')}
                        options={[
                          { value: "0", label: "Seleccionar Trimestre" },
                          { value: "1", label: "1° trimestre" },
                          { value: "2", label: "2° trimestre" },
                          { value: "3", label: "3° trimestre" },
                        ]}
                      />
                    </Col>
                  </Row>
                </>
              )}

              {initialValues.subject_id === 16 && (
                <>
                  {/* ENGLISH 2425 */}
                  {/* <Row style={{ marginBottom: 20 }}>
                    <Col span={6}>
                      <label htmlFor=""> Páginas</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        placeholder="Ej: 1 - 2 - 3 ..."
                        name="sep_book_pages_english"
                        title="Páginas del libro"
                        type="text"
                        value={initialValues.sep_book_pages_english}
                        className={styles.formFields}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                          setInitialValues({
                            ...initialValues,
                            sep_book_pages_english: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col span={4} offset={1}>
                      <div style={{ marginTop: 30 }}>
                        <Field
                          type="checkbox"
                          name="published"
                          checked={initialValues.english}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setInitialValues({
                              ...initialValues,
                              english: e.target.checked,
                              month: 1,
                            });
                          }}
                        />
                        <label htmlFor="english" style={{ marginLeft: "10px" }}>
                          Inglés 2024/2025
                        </label>
                      </div>
                    </Col>
                    <Col span={6}>
                      <label htmlFor=""> Dosificación por semana</label>
                      <Field
                        errors={errors}
                        touched={touched}
                      <Select
                        className={styles.formFields}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        defaultValue={
                          initialValues.threemester_english
                            ? [`${Number(initialValues.threemester_english)}`]
                            : ["0"]
                        }
                        onChange={handleChangeTrimester('english')}
                        options={[
                          { value: "0", label: "Seleccionar Trimestre" },
                          { value: "1", label: "1° trimestre" },
                          { value: "2", label: "2° trimestre" },
                          { value: "3", label: "3° trimestre" },
                        ]}
                      />
                    </Col>
                  </Row> */}

                  {/* ENGLISH 2526 */}
                  <Row style={{ marginBottom: 20 }}>
                    <Col span={6}>
                      <label htmlFor=""> Páginas</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        placeholder="Ej: 1 - 2 - 3 ..."
                        name="sep_book_pages_english_2526"
                        title="Páginas del libro"
                        type="text"
                        value={initialValues.sep_book_pages_english_2526}
                        className={styles.formFields}
                        onChange={handleChangeBookPages('english_2526')}
                      />
                    </Col>
                    <Col span={4} offset={1}>
                      <div style={{ marginTop: 30 }}>
                        <Field
                          type="checkbox"
                          name="published"
                          checked={initialValues.english_2526}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setInitialValues({
                              ...initialValues,
                              english_2526: e.target.checked,
                            });
                          }}
                        />
                        <label htmlFor="english" style={{ marginLeft: "10px" }}>
                          Inglés Thrive 2025/2026
                        </label>
                      </div>
                    </Col>
                    <Col span={6}>
                      <label htmlFor=""> Dosificación por semana</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        name="week_english_2526"
                        title="Dosificación por semana"
                        type="number"
                        defaultValue={initialValues.week_english_2526}
                        className={styles.formFields}
                        onChange={handleChangeWeek('english_2526')}
                      />
                    </Col>
                    <Col span={1}></Col>
                    <Col span={6}>
                      <label htmlFor="">Trimestre</label>
                      <Select
                        className={styles.formFields}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        defaultValue={
                          initialValues.threemester_english_2526
                            ? [
                                `${Number(
                                  initialValues.threemester_english_2526
                                )}`,
                              ]
                            : ["0"]
                        }
                        onChange={handleChangeTrimester('english_2526')}
                        options={[
                          { value: "0", label: "Seleccionar Trimestre" },
                          { value: "1", label: "1° trimestre" },
                          { value: "2", label: "2° trimestre" },
                          { value: "3", label: "3° trimestre" },
                        ]}
                      />
                    </Col>
                  </Row>

                  {/* ENGLISH 2526 SPARK */}
                  <Row style={{ marginBottom: 20 }}>
                    <Col span={6}>
                      <label htmlFor=""> Páginas</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        placeholder="Ej: 1 - 2 - 3 ..."
                        name="sep_book_pages_english_2526_spark"
                        title="Páginas del libro"
                        type="text"
                        value={initialValues.sep_book_pages_english_2526_spark}
                        className={styles.formFields}
                        onChange={handleChangeBookPages('english_2526_spark')}
                      />
                    </Col>
                    <Col span={4} offset={1}>
                      <div style={{ marginTop: 30 }}>
                        <Field
                          type="checkbox"
                          name="english_2526_spark"
                          checked={initialValues.english_2526_spark}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setInitialValues({
                              ...initialValues,
                              english_2526_spark: e.target.checked,
                            });
                          }}
                        />
                        <label htmlFor="english" style={{ marginLeft: "10px" }}>
                          Inglés Spark 2025/2026
                        </label>
                      </div>
                    </Col>
                    <Col span={6}>
                      <label htmlFor=""> Dosificación por semana</label>
                      <Field
                        errors={errors}
                        touched={touched}
                        name="week_english_2526_spark"
                        title="Dosificación por semana"
                        type="number"
                        defaultValue={initialValues.week_english_2526_spark}
                        className={styles.formFields}
                        onChange={handleChangeWeek('english_2526_spark')}
                      />
                    </Col>
                    <Col span={1}></Col>
                    <Col span={6}>
                      <label htmlFor="">Trimestre</label>
                      <Select
                        className={styles.formFields}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        defaultValue={
                          initialValues.threemester_english_2526_spark
                            ? [
                                `${Number(
                                  initialValues.threemester_english_2526_spark
                                )}`,
                              ]
                            : ["0"]
                        }
                        onChange={handleChangeTrimester('english_2526_spark')}
                        options={[
                          { value: "0", label: "Seleccionar Trimestre" },
                          { value: "1", label: "1° trimestre" },
                          { value: "2", label: "2° trimestre" },
                          { value: "3", label: "3° trimestre" },
                        ]}
                      />
                    </Col>
                  </Row>
                </>
              )}

              {/* READING */}
              <Row style={{ marginBottom: 20 }}>
                <Col span={6}>
                  <label htmlFor=""> Páginas</label>
                  <Field
                    errors={errors}
                    touched={touched}
                    placeholder="Ej: 1 - 2 - 3 ..."
                    name="sep_book_pages_reading"
                    title="Páginas del libro"
                    type="text"
                    value={initialValues.sep_book_pages_reading}
                    className={styles.formFields}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      setInitialValues({
                        ...initialValues,
                        sep_book_pages_reading: e.target.value,
                      });
                    }}
                  />
                </Col>
                <Col span={4} offset={1}>
                  <div style={{ marginTop: 30 }}>
                    <Field
                      type="checkbox"
                      name="published"
                      checked={initialValues.reading}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setInitialValues({
                          ...initialValues,
                          reading: e.target.checked,
                          month: 1,
                        });
                      }}
                    />
                    <label htmlFor="reading" style={{ marginLeft: "10px" }}>
                      Lectura
                    </label>
                  </div>
                </Col>
                <Col span={6}>
                  <label htmlFor=""> Dosificación por semana</label>
                  <Field
                    errors={errors}
                    touched={touched}
                    name="week_reading"
                    title="Dosificación por semana"
                    type="number"
                    defaultValue={initialValues.week_reading}
                    className={styles.formFields}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      setInitialValues({
                        ...initialValues,
                        week_reading: Number(e.target.value),
                      });
                    }}
                  />
                </Col>
                <Col span={1}></Col>
                <Col span={6}>
                  <label htmlFor="">Trimestre</label>
                  <Select
                    className={styles.formFields}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    defaultValue={
                      initialValues.threemester_reading
                        ? [`${Number(initialValues.threemester_reading)}`]
                        : ["0"]
                    }
                    onChange={handleChangeTrimester('reading')}
                    options={[
                      { value: "0", label: "Seleccionar Trimestre" },
                      { value: "1", label: "1° trimestre" },
                      { value: "2", label: "2° trimestre" },
                      { value: "3", label: "3° trimestre" },
                    ]}
                  />
                </Col>
              </Row>

              <Row>
                <Col span={17}>
                  <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <Field
                      type="checkbox"
                      name="published"
                      checked={initialValues.hide_course_for_students}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setInitialValues({
                          ...initialValues,
                          hide_course_for_students: e.target.checked,
                        });
                      }}
                    />
                    <label htmlFor="reading" style={{ marginLeft: "10px" }}>
                      Esconder curso para alumnos en acceso libre
                    </label>
                  </div>
                </Col>
              </Row>

              <Row style={{ marginBottom: 20 }}>
                <label htmlFor="axes">Eje(s)</label>
                <Select
                  mode="tags"
                  className={styles.formFieldSelect}
                  onChange={handleChangeAxes}
                  defaultValue={
                    initialValues?.axes
                      ? initialValues.axes?.map((axe, index: number) => {
                          return `${axe.id}-${axe.name}`;
                        })
                      : undefined
                  }
                >
                  {axeSelectChildren}
                </Select>
                <ErrorMessage
                  name="axes"
                  component="div"
                  className={styles.error}
                />
              </Row>

              <Row style={{ marginBottom: 20 }}>
                <label htmlFor="theme">Tema(s)</label>
                <Select
                  mode="tags"
                  className={styles.formFieldSelect}
                  defaultValue={
                    initialValues?.themes
                      ? initialValues.themes?.map((theme) => {
                          return `${theme.id}-${theme.name}`;
                        })
                      : undefined
                  }
                  onChange={handleChangeThemes}
                >
                  {theme?.map((theme: GetThemes_getThemes, index: number) => {
                    return (
                      <Option
                        value={`${theme?.id}-${theme?.name}`}
                        key={index + `${new Date()}`}
                      >
                        {theme?.name}
                      </Option>
                    );
                  })}
                </Select>
              </Row>

              <Row style={{ marginBottom: 20 }}>
                <label htmlFor="theme">Tag(s)</label>
                <Select
                  mode="tags"
                  className={styles.formFieldSelect}
                  defaultValue={
                    initialValues?.tags
                      ? initialValues.tags?.map((tag) => {
                          return `${tag.id}-${tag.name}`;
                        })
                      : undefined
                  }
                  onChange={handleChangeTags}
                >
                  {tagSelectChildren}
                </Select>
              </Row>

              <div style={{ marginTop: 20, marginBottom: 40 }}>
                <label htmlFor="lessons">Lecciones ASOCIADAS AL CURSO</label>
                <Select
                  mode="multiple"
                  className={styles.formFieldSelect}
                  value={undefined}
                  onChange={handleChangeLessons}
                  defaultValue={
                    lessonSelected
                      ? lessonSelected?.map(
                          (
                            lesson: GetCourses_getCourses_lessons,
                            index: number
                          ) => {
                            return `${resolveLessonType(
                              lesson?.lesson_type!
                            )}-${lesson?.id}-${lesson?.title}`;
                          }
                        )
                      : undefined
                  }
                >
                  {lesson
                    ?.filter((lesson) => lesson.course_id === null)
                    .map((lesson, index: number) => {
                      return (
                        <Option
                          value={`${resolveLessonType(lesson?.lesson_type!)}-${
                            lesson?.id
                          }-${lesson?.title}`}
                          key={index + `${new Date().getTime()}`}
                        >
                          {`${resolveLessonType(lesson?.lesson_type!)}-${
                            lesson?.id
                          }-${lesson?.title}`}
                        </Option>
                      );
                    })}
                </Select>
                <br />
              </div>

              <div
                style={{
                  marginTop: 20,
                  marginBottom: 40,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>
                  Éste botón sirve para distribuir las lecciones asociadas al
                  curso en los programas 2425 y 2526
                </label>
                <Col span={6} style={{ marginTop: 10 }}>
                  <Button type="ghost" onClick={handleDistributeLessons}>
                    Distribuir
                  </Button>
                </Col>
              </div>

              {(initialValues.nem || initialValues.program_2526) && (
                <>
                  <div style={{ marginTop: 20 }} />
                  <label htmlFor="lessons">
                    LECCIONES PROGRAMA 2024/2025 | NEM
                  </label>
                  <Select
                    mode="multiple"
                    className={styles.formFieldSelect}
                    value={undefined}
                    onChange={handleChangeLessons2425}
                    defaultValue={
                      lessonSelected
                        ? lessonSelected
                            ?.filter((lesson) =>
                              initialValues.lessons_2425?.includes(
                                Number(lesson.id)
                              )
                            )
                            .map(
                              (
                                lesson: GetCourses_getCourses_lessons,
                                index: number
                              ) => {
                                return `${resolveLessonType(
                                  lesson?.lesson_type!
                                )}-${lesson?.id}-${lesson?.title}`;
                              }
                            )
                        : undefined
                    }
                  >
                    {lesson
                      ?.filter((lesson) => lesson.course_id === null)
                      .map((lesson, index: number) => {
                        return (
                          <Option
                            value={`${resolveLessonType(
                              lesson?.lesson_type!
                            )}-${lesson?.id}-${lesson?.title}`}
                            key={index + `${new Date().getTime()}`}
                          >
                            {`${resolveLessonType(lesson?.lesson_type!)}-${
                              lesson?.id
                            }-${lesson?.title}`}
                          </Option>
                        );
                      })}
                  </Select>
                  <br />
                  <div style={{ marginBottom: 20 }} />

                  <label htmlFor="lessons">LECCIONES PROGRAMA 2025/2026</label>
                  <Select
                    mode="multiple"
                    className={styles.formFieldSelect}
                    value={undefined}
                    onChange={handleChangeLessons2526}
                    defaultValue={
                      lessonSelected
                        ? lessonSelected
                            ?.filter((lesson) =>
                              initialValues.lessons_2526?.includes(
                                Number(lesson.id)
                              )
                            )
                            .map(
                              (
                                lesson: GetCourses_getCourses_lessons,
                                index: number
                              ) => {
                                return `${resolveLessonType(
                                  lesson?.lesson_type!
                                )}-${lesson?.id}-${lesson?.title}`;
                              }
                            )
                        : undefined
                    }
                  >
                    {lesson
                      ?.filter((lesson) => lesson.course_id === null)
                      .map((lesson, index: number) => {
                        return (
                          <Option
                            value={`${resolveLessonType(
                              lesson?.lesson_type!
                            )}-${lesson?.id}-${lesson?.title}`}
                            key={index + `${new Date().getTime()}`}
                          >
                            {`${resolveLessonType(lesson?.lesson_type!)}-${
                              lesson?.id
                            }-${lesson?.title}`}
                          </Option>
                        );
                      })}
                  </Select>
                  <br />
                  <div style={{ marginBottom: 20 }} />
                </>
              )}

              {(initialValues.english ||
                initialValues.english_2526 ||
                initialValues.english_2526_spark) && (
                <>
                  <div style={{ marginTop: 20 }} />
                  <label htmlFor="lessons">
                    LECCIONES INGLÉS PROGRAMA 2024/2025
                  </label>
                  <Select
                    mode="multiple"
                    className={styles.formFieldSelect}
                    value={undefined}
                    onChange={handleChangeLessons2425}
                    defaultValue={
                      lessonSelected
                        ? lessonSelected
                            ?.filter((lesson) =>
                              initialValues.lessons_2425?.includes(
                                Number(lesson.id)
                              )
                            )
                            .map(
                              (
                                lesson: GetCourses_getCourses_lessons,
                                index: number
                              ) => {
                                return `${resolveLessonType(
                                  lesson?.lesson_type!
                                )}-${lesson?.id}-${lesson?.title}`;
                              }
                            )
                        : undefined
                    }
                  >
                    {lesson
                      ?.filter((lesson) => lesson.course_id === null)
                      .map((lesson, index: number) => {
                        return (
                          <Option
                            value={`${resolveLessonType(
                              lesson?.lesson_type!
                            )}-${lesson?.id}-${lesson?.title}`}
                            key={index + `${new Date().getTime()}`}
                          >
                            {`${resolveLessonType(lesson?.lesson_type!)}-${
                              lesson?.id
                            }-${lesson?.title}`}
                          </Option>
                        );
                      })}
                  </Select>
                  <br />
                  <div style={{ marginBottom: 20 }} />

                  <label htmlFor="lessons">
                    LECCIONES INGLÉS THRIVE 2025/2026
                  </label>
                  <Select
                    mode="multiple"
                    className={styles.formFieldSelect}
                    value={undefined}
                    onChange={handleChangeLessons2526}
                    defaultValue={
                      lessonSelected
                        ? lessonSelected
                            ?.filter((lesson) =>
                              initialValues.lessons_2526?.includes(
                                Number(lesson.id)
                              )
                            )
                            .map(
                              (
                                lesson: GetCourses_getCourses_lessons,
                                index: number
                              ) => {
                                return `${resolveLessonType(
                                  lesson?.lesson_type!
                                )}-${lesson?.id}-${lesson?.title}`;
                              }
                            )
                        : undefined
                    }
                  >
                    {lesson
                      ?.filter((lesson) => lesson.course_id === null)
                      .map((lesson, index: number) => {
                        return (
                          <Option
                            value={`${resolveLessonType(
                              lesson?.lesson_type!
                            )}-${lesson?.id}-${lesson?.title}`}
                            key={index + `${new Date().getTime()}`}
                          >
                            {`${resolveLessonType(lesson?.lesson_type!)}-${
                              lesson?.id
                            }-${lesson?.title}`}
                          </Option>
                        );
                      })}
                  </Select>
                  <br />
                  <div style={{ marginBottom: 20 }} />

                  <label htmlFor="lessons">
                    LECCIONES INGLÉS SPARK 2025/2026
                  </label>
                  <Select
                    mode="multiple"
                    className={styles.formFieldSelect}
                    value={undefined}
                    onChange={handleChangeLessonsAux}
                    defaultValue={
                      lessonSelected
                        ? lessonSelected
                            ?.filter((lesson) =>
                              initialValues.lessons_aux?.includes(
                                Number(lesson.id)
                              )
                            )
                            .map(
                              (
                                lesson: GetCourses_getCourses_lessons,
                                index: number
                              ) => {
                                return `${resolveLessonType(
                                  lesson?.lesson_type!
                                )}-${lesson?.id}-${lesson?.title}`;
                              }
                            )
                        : undefined
                    }
                  >
                    {lesson
                      ?.filter((lesson) => lesson.course_id === null)
                      .map((lesson, index: number) => {
                        return (
                          <Option
                            value={`${resolveLessonType(
                              lesson?.lesson_type!
                            )}-${lesson?.id}-${lesson?.title}`}
                            key={index + `${new Date().getTime()}`}
                          >
                            {`${resolveLessonType(lesson?.lesson_type!)}-${
                              lesson?.id
                            }-${lesson?.title}`}
                          </Option>
                        );
                      })}
                  </Select>
                  <br />
                  <div style={{ marginBottom: 20 }} />
                </>
              )}

              <Buttons
                handleClick={() => {
                  handleReset();
                  navigate(-1);
                }}
              />
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default NewCourses;
